import { useMemo } from "react";

const formatterCache = new Map();

/**
 * formatCurrency
 * @param {number|string|null|undefined} value
 * @param {Object} opts
 * @param {string} opts.currency - ISO 4217 currency code.
 * @param {string} opts.locale - BCP-47 locale.
 * @param {boolean} opts.fallbackZero - If true, non-numeric becomes 0; else returns ''.
 */
export function formatCurrency(
  value,
  {
    currency = "CZK",
    locale = "cs-CZ",
    fallbackZero = true
  } = {}
) {
  const num = Number(value);
  if (!Number.isFinite(num)) {
    if (!fallbackZero) return "";
  }
  const safe = Number.isFinite(num) ? num : 0;
  const key = `${locale}_${currency}`;
  let formatter = formatterCache.get(key);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, { style: "currency", currency });
    formatterCache.set(key, formatter);
  }
  return formatter.format(safe);
}

export function useCurrencyFormatter({ currency = "CZK", locale = "cs-CZ" } = {}) {
  return useMemo(
    () => (v, extra = {}) => formatCurrency(v, { currency, locale, ...extra }),
    [currency, locale]
  );
}